import { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/profile";
import { IconInfoCircle } from "../../../../common/icons/IconInfoCircle/IconInfoCircle";
import LeafTooltip from "../../../../common/leaf/LeafTooltip/LeafTooltip";
import "./MigratedTag.scss";

type Props = {
  isNewMigrated?: boolean;
  aboNo: string;
};

const MigratedTag = (props: Props) => {
  const { isNewMigrated, aboNo } = props;
  const { t } = useTranslation(["profile"]);
  const isNewMigratedOnClick = (event: SyntheticEvent) => {
    event.stopPropagation();
  };
  return isNewMigrated ? (
    <span
      className="tag-migrated"
      onClick={isNewMigratedOnClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          isNewMigratedOnClick(e);
        }
      }}
      role="button"
      tabIndex={0}
    >
      <LeafTooltip
        content={`${t(
          "customerProfile.tags.migratedTooltip",
          defaultContent["customerProfile"]["tags"]["migratedTooltip"],
        )}`}
        id={`migrated_${aboNo}`}
        icon={<IconInfoCircle />}
      />
      {`${t("customerProfile.tags.migrated", defaultContent["customerProfile"]["tags"]["migrated"])}`}
    </span>
  ) : (
    <></>
  );
};

export default MigratedTag;
